module.exports = __webpack_public_path__ + "img/dz.b03e5aec.svg";